import React from 'react';
import { Paper, SxProps } from '@mui/material';

export default function PageWrapper({
  children,
  sx,
}: {
  children: React.ReactNode;
  sx?: SxProps;
}) {
  return (
    <Paper
      square
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        position: 'relative',
        ...sx,
      }}
    >
      {children}
    </Paper>
  );
}
